<template>
  <div class="jaleko-responde">
    <b-alert id="mensagemSucesso" variant="success" dismissible :show="alerta.visivel" @dismissed="alerta.visivel=false">
      <div>Sua dúvida foi enviada com sucesso!</div>
    </b-alert>

    <div class="row mb-3 mt-3 input-pergunta">
      <div class="col-12 col-md-9">
        <input type="text" class="form-control pergunta-disc" v-model="textoPergunta" placeholder="Faça a sua pergunta aqui, que o Jaleko responde"/>
        <div class="invalid-feedback" v-if="erroPergunta">
          Por favor informe a sua dúvida
        </div>
      </div>
      <div class="col-12 col-md-3">
        <button type="button" class="btn btn-perguntar mt-3 mt-md-0 w-100" @click="pesquisarPergunta"><i class="fas fa-spinner fa-spin" v-if="carregandoPerguntas"></i> Perguntar</button>
      </div>
    </div>
    <p class="pergunta mb-4 mt-5" v-show="perguntaRealizada"><i class="fas fa-quote-left"></i>{{ perguntaRealizada }}<i
      class="fas fa-quote-right"></i></p>

    <p v-if="perguntaRealizada.length"><i class="fas fa-spinner fa-spin" v-if="carregandoPerguntas"></i> Veja se a sua pergunta já foi respondida</p>
    <div class="perguntas-respondidas mb-4">
      <div v-for="pergunta in perguntas">
        <p>{{ pergunta.titulo }}</p>
        <p>{{ pergunta.texto }}</p>
      </div>
    </div>

    <p v-show="habilitarRealizarPergunta">Não achou o que queria?</p>
    <div v-show="habilitarRealizarPergunta" class="text-center mt-4 mb-4">
      <a href="javascript:void(0);" @click="enviarPergunta" class="btn btn-secondary"><i class="fas fa-spinner fa-spin" v-if="submit"></i> Continuar com a sua pergunta</a>
      <a href="javascript:void(0);" @click="fazerOutraPergunta" class="btn">Fazer outra pergunta</a>
    </div>
  </div>
</template>

<script>
import BuscaAPI from '@/api/busca-api'
import RelatoDuvidaAPI from '@/api/relato-duvida-api'

export default {
  name: 'JalekoResponde',
  props: {
    ementaId: Number
  },
  data () {
    return {
      alerta: { visivel: false },
      submit: false,
      textoPergunta: '',
      erroPergunta: false,
      perguntaRealizada: '',
      habilitarRealizarPergunta: false,
      perguntas: [],
      carregandoPerguntas: false
    }
  },
  methods: {
    scrollTo: function ($element) {
      $element.scrollIntoView({ block: 'start', behavior: 'smooth' })
    },

    fazerOutraPergunta: function () {
      this.textoPergunta = ''
      this.perguntaRealizada = ''
      this.habilitarRealizarPergunta = false
      this.perguntas = []
      this.erroPergunta = false
      this.carregandoPerguntas = false

      this.scrollTo(this.$el.querySelector('.input-pergunta'))
    },

    enviarPergunta: function () {
      this.submit = true
      RelatoDuvidaAPI.enviarRelatoDuvida(this.ementaId, this.perguntaRealizada).then(() => {
        this.alerta.visivel = true
      }).catch(error => {
        console.log('error', error)
      }).then(() => {
        this.submit = false

        this.fazerOutraPergunta()
        this.scrollTo(this.$el.querySelector('#mensagemSucesso'))
      })
    },

    pesquisarPergunta: function () {
      this.perguntas = []
      this.erroPergunta = false

      if (this.textoPergunta.length) {
        this.carregandoPerguntas = true

        this.perguntaRealizada = this.textoPergunta

        BuscaAPI.pesquisar(this.perguntaRealizada, 'questao', process.env.VUE_APP_EMPRESA_REF).then(data => {
          data.data.forEach(item => {
            this.perguntas.push({ titulo: this.perguntaRealizada, texto: item.texto })
          })
        }).then(() => {
          this.habilitarRealizarPergunta = true
          this.carregandoPerguntas = false
        })
      } else {
        this.erroPergunta = true
      }
    }
  }
}
</script>

<style scoped>
  .invalid-feedback {
    display: block;
  }
</style>
